var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "regist selectClubs" },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm._l(_vm.leagues, function (league) {
        return _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.selectedLeague,
              expression: "selectedLeague",
            },
          ],
          key: league,
          staticClass: "hiddenTrig",
          attrs: { type: "radio", name: "league", id: "league" + league },
          domProps: {
            value: league,
            checked: _vm._q(_vm.selectedLeague, league),
          },
          on: {
            change: function ($event) {
              _vm.selectedLeague = league
            },
          },
        })
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "leagueToggle" },
        [
          _c(
            "ul",
            { staticClass: "selectLeague" },
            _vm._l(_vm.leagues, function (league) {
              return _c(
                "li",
                {
                  key: league,
                  attrs: { tabindex: 0 },
                  on: {
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.selectLeague(league)
                    },
                  },
                },
                [
                  _c(
                    "label",
                    {
                      class: {
                        active: _vm.selectedLeague === league,
                        [league.toLowerCase()]: true,
                      },
                      attrs: { for: "league" + league },
                    },
                    [_vm._v(_vm._s(league))]
                  ),
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _vm._l(_vm.leagues, function (league) {
            return _c(
              "ul",
              { class: ["clubList", "setting", league.toLowerCase()] },
              _vm._l(_vm.getSpecifiedClubTeams(league), function (club) {
                return _c("li", { key: club.clubCode }, [
                  _c("div", { staticClass: "club-team" }, [
                    _c("img", {
                      attrs: {
                        src: _vm.emblemImagePath(club.emblemImg),
                        alt: club.teamName,
                      },
                    }),
                    _vm._v(_vm._s(club.teamName) + "\n                    "),
                    _c(
                      "label",
                      {
                        staticClass: "mail-setting",
                        attrs: { tabindex: _vm.getTabIndex(league) },
                        on: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.goToPlayerSelection(
                              club.clubCode,
                              $event
                            )
                          },
                        },
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.selectedClubCodes,
                              expression: "selectedClubCodes",
                            },
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            value: club.clubCode,
                            checked: Array.isArray(_vm.selectedClubCodes)
                              ? _vm._i(_vm.selectedClubCodes, club.clubCode) >
                                -1
                              : _vm.selectedClubCodes,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.goToPlayerSelection(
                                club.clubCode,
                                $event
                              )
                            },
                            change: function ($event) {
                              var $$a = _vm.selectedClubCodes,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = club.clubCode,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.selectedClubCodes = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.selectedClubCodes = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.selectedClubCodes = $$c
                              }
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm._m(1, true),
                      ]
                    ),
                  ]),
                ])
              }),
              0
            )
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "btnSpace duo" },
        [
          _c(
            "button",
            {
              staticClass: "return",
              attrs: { type: "button" },
              on: { click: _vm.back },
            },
            [_vm._v("戻る")]
          ),
          _vm._v(" "),
          _c("xhr-button", {
            attrs: {
              "is-xhr": _vm.isXhr,
              id: "club_regist_tap2",
              "button-label": "確認",
            },
            on: { "on-click": _vm.next },
          }),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "aCt" }, [
      _vm._v("\n        お気に入り選手は3クラブまで登録できます。"),
      _c("br"),
      _vm._v("\n        1クラブあたり3名の選手を登録できます。\n    "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("b", [_c("i", { staticClass: "fas fa-portrait" })])
  },
]
render._withStripped = true

export { render, staticRenderFns }